/* eslint-disable */
import { DataType, Middleware } from "@sa/rep-common";
import { DataFlowProcessingState, MultiValueParameter, ParameterBase, SingleValueParameter } from "@sa/rep-core";
import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { ServiceProvider } from "@sa/rep-services-provider";
import { arrayByLength } from "../../../../../shared";
import { ServicesRegister } from "../../../shared";
import { REPORT_ID } from '../constants';



function initParameter(parameterId: string, parameters: Map<string, ParameterBase>, value: unknown | unknown[]) {
  let parameter: SingleValueParameter | MultiValueParameter;
  if (parameters.has(parameterId)) {
    parameter = parameters.get(parameterId) as SingleValueParameter | MultiValueParameter;
    const singlePreicate = parameter instanceof SingleValueParameter && (parameter.value === null || parameter.value === undefined);
    const multiPreicate = parameter instanceof MultiValueParameter && (!parameter.value || parameter.value.length === 0);
    if (singlePreicate || multiPreicate) {
      parameter.value = value;
    }
  } else {
    if (Array.isArray(value)) {
      parameter = new MultiValueParameter(parameterId, DataType.Number, false, value, () => undefined);
    } else {
      parameter = new SingleValueParameter(parameterId, DataType.Number, false, value, () => undefined);
    }
    parameters.set(parameterId, parameter);
  }
}

export const slide16DataflowMiddlewares = (serviceProvider: ServiceProvider) => {
  const dictionariesServices = serviceProvider.resolve<DictionariesService>(ServicesRegister.Dictionary);
  return (async function (input, next) {
    if ([REPORT_ID].includes(input.reportId)) {
      
    }
    return next(input);
  }) as Middleware<DataFlowProcessingState>
};  
